import {
	PREMIUM_EDITION,
	STANDARD_EDITION,
	getEdition,
	toEdition,
} from '@jira/platform__application-editions/src/edition.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import { JIRA_PRODUCT_DISCOVERY } from '@atlassian/jira-shared-types/src/application.tsx';
import { useAppEditions } from '@atlassian/jira-tenant-context-controller/src/components/app-editions/index.tsx';

export const useIsPremiumEdition = (): boolean => {
	const appEditions = useAppEditions();

	const jpdEdition = getEdition(JIRA_PRODUCT_DISCOVERY, appEditions);

	// TODO: POL-10089 use entitlements instead of the edition when it will be available
	return jpdEdition === toEdition(PREMIUM_EDITION);
};

export const useIsStandardEdition = (): boolean => {
	const appEditions = useAppEditions();

	const jpdEdition = getEdition(JIRA_PRODUCT_DISCOVERY, appEditions);

	return jpdEdition === toEdition(STANDARD_EDITION);
};

export const useIsViewPermissionsEnabled = (): boolean => {
	const isPremium = useIsPremiumEdition();

	return isPremium;
};

export const useIsCrossProjectViewsEnabled = (): boolean => {
	const isPremium = useIsPremiumEdition();

	return isPremium;
};

export const useIsConnectionsEnabled = (): boolean => {
	const isPremium = useIsPremiumEdition();
	const isStandard = useIsStandardEdition();

	if (!fg('jpd_itr-beta-removal-release')) {
		if (isStandard && fg('jpd_issues_relationships_eap_lighthouse_customer')) {
			return true;
		}
	}

	return isPremium;
};
